<template>
  <div class="body-div">
    <ul class="config-ul">
      <li v-for="item in configurationList" :class="{ active: activeId === item.id }" :key="item.id"
        @click="configBtn(item)">{{ item.name }}</li>
    </ul>
    <div style="margin: 16px 16px 0;text-align: center;padding-bottom: 20px;" v-show="activeId == 1">
      <el-button type="primary" @click="getUserList" style="float: right;">查询</el-button>
      <el-input style="width:230px;float: right;margin-bottom: 16px;" placeholder="关键字搜索" ref="multipleTable"
        v-model="queryParams.keyWord" clearable></el-input>
      <el-table :data="UserData" style="width: 100%;margin: 16px 0;" border>
        <el-table-column type="index" width="100" label="序号" align="center">
        </el-table-column>
        <el-table-column prop="universitySharingUn" min-width="200" label="账号" align="center">
        </el-table-column>
        <el-table-column prop="realName" min-width="200" label="姓名" align="center">
        </el-table-column>
        <el-table-column prop="roleName" min-width="200" label="所属角色" align="center">
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="queryParams.pageNo" :page-sizes="[20, 50, 100, 200, 300, 400]"
        :page-size="queryParams.pageSize" layout="total,sizes, prev, pager, next" :total="usertotal">
      </el-pagination>
    </div>
    <div style="margin: 16px 16px;text-align: center;padding-bottom: 20px;" v-show="activeId == 2">
      <el-button type="primary" @click="getList" style="float: right;">查询</el-button>
      <el-input style="width:230px;float: right;margin-bottom: 16px;" placeholder="关键字搜索" ref="multipleTable"
        v-model="queryParamser.keyWord" clearable></el-input>
        <el-select v-model="queryParamser.isSubmit" style="float: right;" placeholder="请选择" clearable>
        <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <el-table :data="tableData" style="width: 100%;margin: 16px 0;" border>
        <el-table-column prop="ipAdress" width="120" label="ip" align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="user_Name" width="150" label="账号" align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="real_Name" width="100" label="姓名" align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="role_Name" width="100" label="所属角色" align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="deviceInformation" width="150" label="设备信息" align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="browserInformation" width="150" label="浏览器信息" align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="virName" min-width="200" label="实验名称" align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="submit_Time" width="160" label="操作时间" align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="是否提交" align="center" width="100" class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <span v-show="scope.row.isSubmit == 1">提交</span>
            <span v-show="scope.row.isSubmit == 2">未提交</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="100" class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <el-button v-show="scope.row.isSubmit == 1" type="primary" size="mini"
              @click="getInfo(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChangeer" @current-change="handleCurrentChangeer"
        :current-page.sync="queryParamser.pageNo" :page-sizes="[20, 50, 100, 200, 300, 400]"
        :page-size="queryParamser.pageSize" layout="total,sizes, prev, pager, next" :total="total">
      </el-pagination>
    </div>
    <Modal v-model="showResultuser" fullscreen ok-text="关闭">
      <div class="">
        <div class="results_page_out">
          <!-- 头部 -->
          <div class="top">
            <h1 class="typeface">{{ this.Vir_datauser.VirName }}</h1>
          </div>
          <!-- 用户姓名和得分 -->
          <div class="con">
            <p class="name">
              <span>姓名：{{ this.Vir_datauser.stureal_name }}</span>
              <span>用户名：{{ this.Vir_datauser.stuuser_name }}</span>
            </p>
            <h2 class="score">
              <span>
                实验得分：
                <strong style="color: red">{{
                  this.Vir_datauser.resultScore
                }}</strong>
              </span>
              <span style="font-size: 16px">
                <em>实验(得分/分值：{{ numFilter(this.Vir_datauser.Score) }}/{{
                  this.Vir_datauser.Total_score
                }})</em>
              </span>
            </h2>
          </div>
          <!-- 实验的列表步骤 -->
          <div class="list_out">
            <div class="list" v-for="(item, indexs) in this.Vir_datauser.Virinfo">
              <h4>
                {{ item.expmName }}
              </h4>
              <div class="left">
                <table>
                  <tr class="title">
                    <td width="61%">步骤名称</td>
                    <td width="13%">分数</td>
                    <td width="13%" v-if="item.RightAnswers != null && item.RightAnswers != ''
                      ">
                      对错情况
                    </td>
                    <td width="13%">完成情况</td>
                  </tr>
                  <tr>
                    <td>
                      {{ item.Title != null ? item.Title : item.stepDesc }}
                    </td>
                    <td>{{ item.Score }}</td>
                    <td :style="item.IsRight == 1 ? 'color:green' : 'color:red'" v-if="item.RightAnswers != null && item.RightAnswers != ''
                      ">
                      {{ item.IsRight == 1 ? "正确" : "错误" }}
                    </td>
                    <td :style="item.IsDone == 1 ? 'color:green' : 'color:red'">
                      {{ item.IsDone == 1 ? "已完成" : "未完成" }}
                    </td>
                  </tr>
                </table>
                <dl class="question" v-if="item.RightAnswers != null && item.RightAnswers != ''">
                  <span style="display: none">{{
                    item.Options.indexOf("?@")
                  }}</span>
                  <!-- 兼容?@和逗号分隔的数据，5月21日按照要求api改为?@'防止实验的数据本身带有逗号 -->
                  <!-- 用?@分隔 -->
                  <dd v-if="item.Options.indexOf('?@') > -1" v-for="(option, j) in item.Options.split('?@')">
                    <label class="option">
                      {{ Letteruser[j] }}.
                      <p class="ue" style="display: inline">
                        {{ option }}
                      </p>
                    </label>
                  </dd>
                  <!-- 用逗号分隔 -->
                  <dd v-else v-for="(option1, j1) in item.Options.split(',')">
                    <label class="option">
                      {{ Letteruser[j1] }}.
                      <p class="ue" style="display: inline">
                        {{ option1 }}
                      </p>
                    </label>
                  </dd>
                </dl>
                <div class="answer" v-if="item.RightAnswers != null && item.RightAnswers != ''">
                  <p class="right_key">
                    正确答案：
                    <!-- 用?@分隔 -->
                    <span v-if="item.RightAnswers.indexOf('?@') > -1" v-for="trueoption in item.RightAnswers.split('?@')">
                      {{ Letteruser[trueoption] }}&nbsp;</span>
                    <span v-else v-for="trueoption1 in item.RightAnswers.split(',')">
                      {{ Letteruser[trueoption1] }}&nbsp;
                    </span>
                  </p>

                  <p class="user_answers">
                    用户答案：
                    <!-- 用?@分隔 -->
                    <span v-if="item.UserAnswers.indexOf('?@') > -1" v-for="useroption in item.UserAnswers.split('?@')">{{
                      Letteruser[useroption] }}</span>
                    <span v-else v-for="useroption1 in item.UserAnswers.split(',')">
                      {{ Letteruser[useroption1] }}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import axios from "axios"
export default {
  name: 'HomeView',
  data() {
    return {
      options:[
      { id: 1, name: '提交' }, { id: 2, name: '未提交' },
      ],
      configurationList: [
        { id: 2, name: '操作日志' }, { id: 1, name: '用户管理' },
      ],
      activeId: 2,
      // 查询参数
      queryParams: {
        pageNo: 1,
        pageSize: 20,
        keyWord: '',
      },
      // 查询参数
      queryParamser: {
        pageNo: 1,
        pageSize: 20,
        keyWord: '',
        isSubmit:''
      },
      VirTitleuser: "", //模态框实验名称
      total: 0,
      usertotal: 0,
      classList: [{ id: 1, name: '用户管理' }, { id: 2, name: '操作日志' }],
      UserData: [],
      tableData: [],
      showResultuser: false,
      Vir_datauser: {}
    }
  },
  methods: {
    //判断是否显示
    isDisplay(index, item) {
      console.log(index, item)
      var result = true;
      let settingObj = this.Vir_datauser.Virinfo;
      let settingArr = Object.keys(settingObj).map((key) => {
        return settingObj[key]; //把每个对象返回出去生成一个新的数组中相当于0:{id:1}
      });
      // eslint-disable-next-line eqeqeq
      if (index !== 0) {
        var index1 = parseInt(index - 1);
        var indexname = item.expmName;

        var indexsname = settingArr[index1].expmName;

        if (indexname === indexsname) {
          result = false;
        } else {
          result = true;
        }
      } else {
        result = true;
      }
      return result;
      //result;
    },
    getInfo(item) {
      console.log(item);
      this.Vir_datauser = [];
      axios.get(GlobalVariable.BaseUrl + '/Vir_Virtualexperiment_ResultInfo/apiGetVir_Virtualexperiment_ResultInfoList?Parent_id=' + item.id)
        .then(response => {
          this.Vir_datauser.Virinfo = response.data.Result.Data;
          this.Vir_datauser.VirName = item.virName + "成绩";
          this.Vir_datauser.stureal_name = item.realName;
          this.Vir_datauser.stuuser_name = item.user_Name;
          this.Vir_datauser.resultScore =
            item.allScore == 100 ? item.score : item.resultScore;
          this.Vir_datauser.Total_score =
            item.allScore == 0 || item.allScore === "undefined" ? 100 : item.allScore;
          this.Vir_datauser.Score = item.score; //考核成绩
          this.showResultuser = true;
        })
        .catch(error => {
        });
    },
    //截取当前数据到小数点后两位
    numFilter(value) {
      const realVal = parseFloat(value).toFixed(2);
      return realVal;
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getUserList()
    },
    handleCurrentChange(val) {
      this.queryParams.pageNo = val;
      this.getUserList()
    },
    handleSizeChangeer(val) {
      this.queryParamser.pageSize = val;
      this.getList()
    },
    handleCurrentChangeer(val) {
      this.queryParamser.pageNo = val;
      this.getList()
    },
    //获取列表
    getUserList() {
      axios.get(GlobalVariable.BaseUrl + '/ExperimentSharingAssociation/apiGetPagedExperimentSharingAssociations?page=' + this.queryParams.pageNo + '&limit=' + this.queryParams.pageSize + '&keyWord=' + this.queryParams.keyWord)
        .then(response => {
          this.UserData = response.data.result.data;
          this.usertotal = response.data.result.total;
        })
        .catch(error => {
        });
    },
    //获取列表
    getList() {
      axios.get(GlobalVariable.BaseUrl + '/Vir_Virtualexperiment_Result/apiGetPagedVir_Virtualexperiment_Results?page=' + this.queryParamser.pageNo + '&limit=' + this.queryParamser.pageSize + '&keyWord=' + this.queryParamser.keyWord +'&isSubmit='+this.queryParamser.isSubmit)
        .then(response => {
          this.tableData = response.data.result.data;
          for (let i in response.data.result.data) {
            this.tableData[i].submit_Time = response.data.result.data[i].submit_Time.replace("T", " ").split(".")[0];
          }
          this.total = response.data.result.total;
        })
        .catch(error => {
        });
    },
    //切换各个配置
    configBtn(item) {
      this.activeId = item.id;
      if (item.id == 1) {
        this.queryParams = {
          pageNo: 1,
          pageSize: 20,
          keyWord: '',
        };
        this.getUserList()
      } else {
        this.queryParamser = {
          pageNo: 1,
          pageSize: 20,
          keyWord: '',
          isSubmit:''
        }
        this.getList()
      }
    },
  },
  mounted() {
    this.getList();
  },
}
</script>
<style scoped>
/***************  查看结果 ********************/

body::-webkit-scrollbar-button {
  width: 0px;
}

body::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

body::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: #ddd;
}

body {
  margin: 0;
  padding: 20px;
  background: #f6faff;
  min-width: 1200px;
  overflow: auto;
}

.body-div {
  background: #fff;
  margin: 0;
  border-radius: 8px 8px 0 0;
}

.config-ul {
  margin: 0;
  border-radius: 8px 8px 0 0;
  list-style: none;
  display: flex;
  padding: 0;
  font-size: 14px;
  flex-wrap: wrap;
  border-bottom: 1px solid #ddd;
}

.config-ul li {
  width: 120px;
  line-height: 50px;
  border-radius: 8px 8px 0 0;
  text-align: center;
  cursor: pointer;
}

.config-ul li.active {
  color: #fff;
  background: linear-gradient(90deg, rgba(103, 167, 253, 1) 0%, rgba(99, 132, 253, 1) 50%, rgba(95, 102, 253, 1) 100%);
}

.results_page_out {
  padding: 2%;
}

.results_page_out .top {
  background: #D9EDF7;
  width: 100%;
  border-bottom: 1px solid #cccccc;
  text-align: center;
  padding: 20px;
}

.results_page_out .top h1.typeface {
  margin-bottom: 0;
  font-size: 24px;
  line-height: 1.7em;
  color: #148FC9;
  font-weight: bolder;
  letter-spacing: 0.3em;
}

.results_page_out .con {}

.results_page_out .con p.name {
  text-align: center;
  line-height: 1.6em;
  padding: 10px 20px;
  margin: 0;
}

.results_page_out .con p.name span {
  margin: 5px 15px;
  display: inline-block;
  color: #333333;
  font-size: 14px;
}

.results_page_out .con h2.score {
  text-align: center;
  line-height: 1.6em;
  padding: 0 20px 10px;
  margin: 0;
}

.results_page_out .con h2.score span {
  font-size: 22px;
  font-weight: bold;
  display: inline-block;
  margin: 0 15px;
}

.results_page_out .con h2.score span em {
  font-weight: bold;
  display: inline-block;
  margin: 0 10px;
}

.results_page_out .list_out {
  border: 1px solid #cccccc;
}

.results_page_out .list_out .list {
  border-bottom: 1px solid #cccccc;
  margin-bottom: 10px;
}

.results_page_out .list_out .list h4 {
  background: #D9EDF7;
  width: 100%;
  text-align: center;
  padding: 10px;
  font-size: 16px;
  font-weight: bold;
  color: #444;
  margin-bottom: 0;
}

.results_page_out .list_out .list .left {
  width: 100%;
  padding: 4px;
}

.results_page_out .list_out .list .left table {
  border: 1px solid #cccccc;
  width: 100%;
}

.results_page_out .list_out .list .left table tr {
  border: 1px solid #cccccc;
}

.results_page_out .list_out .list .left table tr td {
  border: 1px solid #cccccc;
  vertical-align: middle;
  text-align: center;
  padding: 10px 3px;
  font-size: 14px;
}

.results_page_out .list_out .list .left table tr.title td {
  font-weight: bold;
}

.results_page_out .list_out .list .left .question {
  border: 1px dashed #007aff;
  margin: 10px 0;
  padding: 5px 0;
}

.results_page_out .list_out .list .left .question dd {
  padding: 0 10px;
  margin: 5px 0;
  font-size: 14px;
  color: #333333;
}

.results_page_out .list_out .list .left .answer {}

.results_page_out .list_out .list .left .answer .right_key {
  color: #009900;
  font-size: 16px;
  display: block;
  padding: 5px 10px;
  font-weight: bold;
  margin: 0;
}

.results_page_out .list_out .list .left .answer .user_answers {
  color: red;
  font-size: 16px;
  display: block;
  padding: 5px 10px;
  font-weight: bold;
}
</style>
  